import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(theme => ({
  inputRoot: {
    '&$disabled': {
      color:'black'
    },
  },
  disabled: {}
}));

export const useLabelStyles = makeStyles(theme => ({
    root: {
      fontSize: '.75em'
    },
  }));